import { Fragment } from 'react'
import PropTypes from 'prop-types'

import theme from 'theme'
import Dropdown from 'components/common/Dropdown'
import InputTextField from 'components/common/InputTextField'

export const ROLES = ['Developer', 'SRE', 'Manager', 'CTO']

export default function RoleDropdown({
  role,
  roleHasChanged,
  handleRoleChange,
  customRole,
  handleCustomRoleChange
}) {
  return (
    <Fragment>
      <Dropdown
        showLabelOnValue
        css={{
          height: theme.space[5] + theme.space[3],
          marginBottom: theme.space[4]
        }}
        inputStyles={({ isOpen }) => ({
          '& input': {
            marginTop: Boolean(role) && !isOpen ? theme.space[1] : 0,
            '&::placeholder': {
              color: theme.colors.steel[0],
              fontWeight: theme.fontWeights[0]
            }
          }
        })}
        items={[...ROLES, 'Other'].map(r => ({ label: r, value: r }))}
        placeholder="Role"
        selectedValue={role}
        onSelected={value => handleRoleChange(value)}
      />
      {role === 'Other' && roleHasChanged && (
        <InputTextField
          data-test-role-dropdown-title
          label="Title"
          name="title"
          value={customRole}
          onChange={event => handleCustomRoleChange(event.target.value)}
        />
      )}
    </Fragment>
  )
}

RoleDropdown.propTypes = {
  role: PropTypes.string,
  customRole: PropTypes.string,
  roleHasChanged: PropTypes.bool,
  handleRoleChange: PropTypes.func,
  handleCustomRoleChange: PropTypes.func
}
